



































import {Component, Prop, Vue} from 'vue-property-decorator'
import axios from 'axios';

@Component
export default class TaxReturnResult extends Vue {

    @Prop()
    taxYear!: number;

    private polling: any = null;

    private pollingError: string | null = null;
    private submissionError: string | null = null;
    private submissionFailed: boolean = false;

    private get taxPeriod(): string {
        return `${this.taxYear}-${this.taxYear + 1}`
    }

    private beforeDestroy() {
        this.stopPolling();
    }

    private mounted() {
        axios.get(`/tax-return/${this.taxYear}/submission-result-status`)

        this.polling = setInterval(async () => {
            await this.checkStatus()
        }, 5000);
    }

    private async checkStatus() {
        await axios.get(`/tax-return/${this.taxYear}/submission-result-status`)
            .then(result => {
                const data = result.data;
                if (data.redirect) {
                    window.location.href = data.redirect;
                }

                if (data.success === false) {
                    this.submissionFailed = true;
                    this.stopPolling();

                    if (data.submission_error) {
                        this.submissionError = data.submission_error;
                    }
                }

            })
            .catch(error => {
                this.pollingError = error.response?.data.message ||
                    'We encountered an error while checking for your return status. Rest assured, the submission is still in progress and we will email you with the result.';

                this.stopPolling();
            });
    }

    private stopPolling() {
        if (this.polling) {
            clearInterval(this.polling);
            this.polling = null;
        }
    }
}
